import React from 'react';
interface SectionTagProps {
  icon?: string;
  children: React.ReactNode;
  tone?: 'brown' | 'gray';
}
export function SectionTag({
  icon,
  children,
  tone = 'brown'
}: SectionTagProps) {
  return <span className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs sm:text-sm font-semibold uppercase tracking-wider ${tone === 'brown' ? 'border-brown/30 bg-brown/10 text-brown' : 'border-ink/10 bg-ink/5 text-muted'}`} data-id="element-258" data-mp="3no1lqb6fsce8">
      {icon && <span aria-hidden="true" data-id="element-259" data-mp="3sne9cy54tnhv">{icon}</span>}
      {children}
    </span>;
}